import { render, staticRenderFns } from "./ConversionBlock.vue?vue&type=template&id=6310c562&scoped=true&"
import script from "./ConversionBlock.vue?vue&type=script&lang=js&"
export * from "./ConversionBlock.vue?vue&type=script&lang=js&"
import style0 from "./ConversionBlock.vue?vue&type=style&index=0&id=6310c562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310c562",
  null
  
)

export default component.exports